<template>
  <div class="pl-4 pr-4">
    <div class="vx-row whiteBackground p-2">
      <div class="vx-col">
        <div class="barTitles">Gold Weight</div>
        <div class="flex">
          <v-select
            style="min-width: 85px"
            class="mr-4"
            :options="showedWeightMultipier"
            label="weightType"
            v-model="selectedGoldWeightType"
            @input="UpdateGoldWeightType()"
          >
          </v-select>
          <vs-input
            class="goldWeightInputWidth mr-1"
            placeholder="Min"
            v-model="volumeMin"
          ></vs-input>
          <p style="font-weight: 600; align-self: center">-</p>
          <vs-input
            class="goldWeightInputWidth ml-1 mr-4"
            placeholder="Max"
            v-model="volumeMax"
          ></vs-input>
          <vs-button
            :disabled="selectedCategory == null && !searchedFilter"
            type="filled"
            icon="play_arrow"
            @click="FilterVolume"
          ></vs-button>
        </div>
      </div>

      <div class="grayLine mt-2 mb-2 sm:block hidden"></div>

      <div class="vx-col">
        <div class="barTitles">Stones</div>
        <div class="flex mt-2" style="color: #707070; font-weight: 600">
          <vs-checkbox
            :disabled="selectedCategory == null && !searchedFilter"
            v-model="withStone"
            @input="FilterStone('with')"
            >With</vs-checkbox
          >
          <vs-checkbox
            :disabled="selectedCategory == null && !searchedFilter"
            v-model="withoutStone"
            @input="FilterStone('without')"
            >Without</vs-checkbox
          >
        </div>
      </div>

      <div class="grayLine mt-2 mb-2 sm:block hidden"></div>

      <div class="vx-col flex items-center">
        <div class="vx-row">
          <div class="vx-col mr-2" style="width: 240px">
            <v-select
              :disabled="selectedCategory == null && !searchedFilter"
              class="mr-4 w-full mt-2"
              v-model="selectedSortOption"
              :placeholder="$t('Sort_By')"
              :options="sortOptions"
            ></v-select>
          </div>

          <div class="vx-col" style="width: 240px">
            <vs-input
              class="w-full mt-2"
              icon="search"
              v-model="searchFilter"
              @keypress.enter="FilterSearch"
            ></vs-input>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        minFilter ||
        maxFilter ||
        stoneFilter ||
        orderingFilter ||
        searchedFilter
      "
      class="vx-row mt-2"
    >
      <vs-chip
        v-if="minFilter"
        color="primary"
        @click="RemoveFilter('volumeMin')"
        closable
      >
        Min: {{ minFilter }}
      </vs-chip>
      <vs-chip
        v-if="maxFilter"
        color="primary"
        @click="RemoveFilter('volumeMax')"
        closable
      >
        Max: {{ maxFilter }}
      </vs-chip>

      <vs-chip
        v-if="stoneFilter"
        color="primary"
        @click="RemoveFilter('stoneFilter')"
        closable
      >
        Stone:
        <vs-icon
          :icon="stoneFilter == 'true' ? 'done' : 'clear'"
          size="small"
          :color="stoneFilter == 'true' ? 'green' : 'red'"
        ></vs-icon>
      </vs-chip>
      <vs-chip
        v-if="orderingFilter"
        color="primary"
        @click="RemoveFilter('orderingFilter')"
        closable
      >
        Sort: {{ sortOptions.filter((e) => e.id == orderingFilter)[0].label }}
      </vs-chip>

      <vs-chip
        v-if="searchedFilter"
        color="primary"
        @click="RemoveFilter('search')"
        closable
      >
        Search: {{ searchedFilter }}
      </vs-chip>

      <vs-button
        class="pt-2 pb-2 pl-3 pr-3 ml-2"
        @click.native="RemoveFilter('search')"
      >
        Clear All
      </vs-button>
    </div>

    <!-- breadcrumb -->
    <div
      v-if="!searchFilterQuery"
      class="mt-4 flex"
      style="font-size: 1.2rem; font-weight: 500; align-items: center"
    >
      <p style="cursor: pointer" @click="ClearCategory">All Designs</p>

      <p class="ml-2" v-if="selectedCategory != null">></p>

      <p
        v-if="selectedCategory != null"
        class="ml-2"
        :style="
          selectedCollection == null
            ? 'font-weight: 700; font-size: 1.4rem'
            : 'cursor: pointer'
        "
        @click="ClearCollection"
      >
        {{ selectedCategory.title }}
      </p>

      <p class="ml-2" v-if="selectedCollection != null">></p>

      <p
        v-if="selectedCollection != null"
        class="ml-2"
        :style="
          selectedProduct == null ? 'font-weight: 700; font-size: 1.4rem' : ''
        "
      >
        {{ selectedCollection.title }}
      </p>
    </div>

    <div class="w-full">
      <categories
        v-if="selectedCategory == null && !searchFilterQuery"
        @changeCategory="ChangeCategory"
      />
    </div>

    <div>
      <collections
        v-if="
          selectedCategory != null &&
          selectedCollection == null &&
          !searchFilterQuery
        "
        :category="selectedCategory"
        @changeCollection="ChangeCollection"
      />
    </div>
    <div>
      <products
        v-if="
          (selectedCategory != null && selectedCollection != null) ||
          searchFilterQuery
        "
        :collection="selectedCollection"
      />
    </div>
  </div>
</template>

<script>
import Api from "@/api/api";
import API from "@/api/config";

import vSelect from "vue-select";

import Collections from "./components/Collections.vue";
import categories from "./components/AllDesigns.vue";
import products from "./components/Products.vue";

export default {
  data() {
    return {
      searchFilter: null,
      volumeMin: null,
      volumeMax: null,
      withStone: false,
      withoutStone: false,
      selectedGoldWeightType: null,
      sortOptions: [
        {
          id: "-created",
          label: this.$t("Newest_Products"),
        },
        {
          id: "title",
          label: this.$t("Sort_By_Name"),
        },
        {
          id: "average_volume",
          label: this.$t("Light_Products_First"),
        },
        {
          id: "-average_volume",
          label: this.$t("Heavy_Products_First"),
        },
      ],
      selectedSortOption: {
        id: "-created",
        label: this.$t("Newest_Products"),
      },
      selectedCategory: null,
      selectedCollection: null,
      selectedProduct: null,
    };
  },
  methods: {
    RemoveFilter(filter) {
      let params = JSON.parse(JSON.stringify(this.$route.query));
      if (filter == "search") {
        this.searchFilter = null;
        delete params.search;
      }
      if (filter == "volumeMin") {
        this.volumeMin = null;
        delete params.min;
      }

      if (filter == "volumeMax") {
        this.volumeMax = null;
        delete params.max;
      }
      if (filter == "stoneFilter") {
        this.withStone = false;
        this.withoutStone = false;
        delete params.has_stone;
      }
      if (filter == "orderingFilter") {
        this.selectedSortOption = {
          id: "-created",
          label: this.$t("Newest_Products"),
        };
        delete params.ordering;
      }

      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    FilterSearch() {
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));

      if (this.searchFilter != null && this.searchFilter != "") {
        params.search = this.searchFilter;
        delete params.category;
        delete params.collection;
      } else {
        delete params.search;
      }
      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    FilterVolume() {
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));
      if (this.volumeMin != null && this.volumeMin != "") {
        params.min = this.volumeMin;
      } else {
        delete params.min;
      }

      if (this.volumeMax != null && this.volumeMax != "") {
        params.max = this.volumeMax;
      } else {
        delete params.max;
      }

      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    FilterStone(filter) {
      if (filter == "with") {
        this.withoutStone = false;
      } else {
        this.withStone = false;
      }
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));
      if (this.withStone) {
        params.has_stone = true;
        this.$router.push({ query: params }).catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else if (this.withoutStone) {
        params.has_stone = false;
        this.$router.push({ query: params }).catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else {
        if (params.has_stone) {
          delete params.has_stone;
        }
        this.$router.push({ query: params }).catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    UpdateGoldWeightType() {
      var data = {
        nokta_market_gold_type: this.selectedGoldWeightType.weightType.slice(
          0,
          2
        ),
      };
      Api.patch(
        API.BASEURL + API.NOKTA_MARKET_GOLD_TYPE,
        this.HandleUpdateGoldWeightType,
        data
      );
    },
    HandleUpdateGoldWeightType(status) {
      if (status != 200) {
        this.$vs.notify({
          title: "Error",
          text: "Something went wrong",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      }
    },
    ClearCategory() {
      this.selectedCategory = null;
      this.selectedCollection = null;
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));
      delete params.category;
      delete params.collection;
      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    ClearCollection() {
      this.selectedCollection = null;
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));
      delete params.collection;
      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    ChangeCategory(category) {
      this.selectedCategory = category;
    },
    ChangeCollection(collection) {
      this.selectedCollection = collection;
    },
  },
  computed: {
    query() {
      return this.$route.query;
    },
    selectedGoldWeightTypeStore() {
      return this.$store.getters["noktaMarket/selectedWeightMultipier"];
    },
    showedWeightMultipier() {
      return this.$store.getters["noktaMarket/showedWeightMultipier"];
    },
    minFilter() {
      return this.$route.query.min;
    },
    maxFilter() {
      return this.$route.query.max;
    },
    stoneFilter() {
      return this.$route.query.has_stone;
    },
    orderingFilter() {
      return this.$route.query.ordering;
    },
    searchedFilter() {
      return this.$route.query.search;
    },
    searchFilterQuery() {
      return this.$route.query.search ? true : false;
    },
  },
  watch: {
    searchedFilter(newValue) {
      if (newValue == null) {
        let params = JSON.parse(JSON.stringify(this.$route.query));

        this.volumeMin = null;
        delete params.min;
        this.volumeMax = null;
        delete params.max;
        this.withStone = false;
        this.withoutStone = false;
        delete params.has_stone;
        this.selectedSortOption = {
          id: "-created",
          label: this.$t("Newest_Products"),
        };
        delete params.ordering;

        this.$router.push({ query: params }).catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    selectedSortOption(newValue) {
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));
      if (newValue.id == "-created") {
        delete params.ordering;
      } else {
        params.ordering = this.selectedSortOption.id;
      }
      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    query(newValue) {
      if (!newValue.hasOwnProperty("category")) {
        this.selectedCategory = null;
      }
      if (!newValue.hasOwnProperty("collection")) {
        this.selectedCollection = null;
      }
    },
    selectedGoldWeightTypeStore() {
      this.selectedGoldWeightType = this.selectedGoldWeightTypeStore;
    },
    selectedGoldWeightType() {
      this.$store.commit(
        "noktaMarket/CHANGE_SELECTED_WEIGHT_MULTIPIER",
        this.selectedGoldWeightType
      );
    },
  },
  mounted() {
    this.selectedGoldWeightType = this.selectedGoldWeightTypeStore;
    if (this.searchedFilter) {
      this.searchFilter = this.searchedFilter;
    }
  },
  components: {
    vSelect,
    categories,
    Collections,
    products,
  },
};
</script>

<style scoped>
.goldWeightInputWidth {
  max-width: 50px;
}
.barTitles {
  font: normal normal normal Museo Sans;
  color: #434343;
  font-weight: 600;
  padding-bottom: 0.5rem;
}
.whiteBackground {
  background-color: white;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.grayLine {
  border: 1px solid #dedede;
}
</style>

<style lang="scss">
.v-select .vs__dropdown-toggle .vs__actions .vs__clear {
  display: none;
}

.vs-input--icon {
  font-size: 1.5rem;
}
</style>
